import React, { useEffect, useState } from 'react';
import Footer from "./Footer";
import Header from "./Header";
import axios from 'axios';
import image2 from "../Assets/wp3589952.webp";
import { Link } from "react-router-dom";


function ShippingPolicy() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [shippingContent, setShippingContent] = useState("");
  const [isLoading, setIsLoading] = useState(true); // State to manage loading

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const fetchShippingData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}content.php`);
        const { shipping } = response.data.body;

        // Set shippingContent as a string with HTML content
        setShippingContent(shipping.value);
      } catch (error) {
        console.error("Error fetching the shipping policy data", error);
      } finally {
        setIsLoading(false); // Stop loading after data is fetched
      }
    };

    fetchShippingData();
  }, []);


  return (
    <div>
      <div className="main1">
        <Header />
        <div
  className="content-section"
  style={{ backgroundImage: `url(${image2})` }} 
>
          <h1
            style={{
              color: "white",
             
              textAlign: "center",
            }}
          >
            Shipping & Delivery
          </h1>
          <p
            style={{
              display: "flex",
              justifyContent: "center",
              color: "white",
            }}
          >
            <Link to="/" style={{color:"white"}}>
              Home
            </Link> <i className="bi bi-chevron-right"></i> Shipping & Delivery
          </p>
        </div>
        <div className='shipping-content'>
          {/* Render shipping content as HTML */}
          <div dangerouslySetInnerHTML={{ __html: shippingContent }} />
        </div>
      </div>
      <br/> <br/><br/>
      <Footer />
      
    </div>
  );
}

export default ShippingPolicy;
